import {Image, SafeAreaView, Text, TouchableOpacity, View} from 'react-native';
import React from 'react';
import {useTheme} from 'contexts/ThemeContext';
import styleSheet from './styles';
import strings from '../../../translations';
import SignInWithGoogleButton from '../signInWithGoogleButton';

interface ILogin {
  onPress(): void;
}

const Login: React.FC<ILogin> = ({onPress}) => {
  const styles = styleSheet(useTheme());
  const theme = useTheme();

  return (
    <View style={styles.containerStyle}>
      <SafeAreaView style={styles.safeAreaStyle}>
        <View style={styles.leftEllipseStyle}>
          <Image
            source={theme.images.leftEllipseGradient}
            blurRadius={25}
            style={styles.leftEllipseImageStyle}
          />
        </View>

        <View style={styles.contentContainerStyle}>
          <Text style={styles.titleStyle}>{strings.loginScreen.title}</Text>

          <Text style={styles.subTitleStyle}>
            {strings.loginScreen.subTitle}
          </Text>

          <View style={styles.imageContainerStyle}>
            <View style={styles.heroImageStyle}>
              <Image
                source={theme.images.heroImageLoginScreen}
                style={styles.heroImage}
              />
            </View>

            <View style={styles.rightEllipseStyle}>
              <Image
                source={theme.images.rightEllipseGradient}
                blurRadius={40}
                style={styles.rightEllipseImageStyle}
              />
            </View>
          </View>

          <SignInWithGoogleButton onPress={onPress} />
        </View>
      </SafeAreaView>
    </View>
  );
};

export default Login;
